import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(
    private http: HttpClient,
    private appGlobals: AppGlobals
  ) { }

  getSupplierItemWiseSummaryReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-item-report`, { params: filters });
  }

  getSupplierInvoiceSummaryReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-invoice-summary-report`, { params: filters });
  }

  getTDSReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}tds-report`, { params: filters });
  }

  getTCSReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}tcs-report`, { params: filters });
  }

  getSupplierWiseReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}supplier-wise-report`, { params: filters });
  }

  getItemWiseReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}item-wise-report`, { params: filters });
  }

  getPushToPetpoojaStatusReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}push-to-petpooja-report`, { params: filters });
  }

  getPushToInvoiceStatusReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}push-to-invoice-report`, { params: filters });
  }

  getPettyExpenseReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}petty-expense-report`, { params: filters });
  }

  getPaymentReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}payment-report`, { params: filters });
  }

  getPurchaseExpense(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}purchase-expense-report`, { params: filters });
  }

  getPurchaseDistribution(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}purchase-distribution-report`, { params: filters });
  }

  getItemPriceGapAnalysis(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.dashboard}product-price-detail`, filters);
  }

  getCompanyDetails(company = null) {
    if (company) {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details?company=${company}`);
    } else {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details`);
    }
  }

  getAdminPushToPetpoojaReport() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}admin-push-to-petpooja-report`)
  }

  getQualityIssueReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<{ issues: any[], total: number, truncated: boolean }>(`${this.appGlobals.apiUrl.metadata}quality-issue/list`, { params: filters });
  }

  hasAdminAccess() {
    return this.http.get(`${this.appGlobals.apiUrl.metadata}admin/access`);
  }
}
